<template>
	<div style="height:100%;" align="Center" v-if="$store.getters.isInternalUser">
		<div id="overall-body">
			<!-- body start -->
			<div id="body-container" align="left">
				<table id="body-table" cellspacing="0" cellpadding="0">
					<tbody>
						<tr>
							<!-- MainBody Starts -->
							<td id="main-container">
								<table width="100%" cellspacing="5" cellpadding="0" border="0">
									<tbody>
										<tr valign="top">
											<td valign="top" align="left">
												<div class="full-width">
													<div class="grid" style="border: 1px solid black; margin: 0 2rem; text-align: right;">
														<div class="col-2">
															<div class="col css-image compass-logo" style="height:60px">
															</div>
														</div>
														<div class="col">
															<span style="font-size: 10px;">
																Unit J, Building 2, 3 Ceres Court PO Box 303484, North Harbour, Auckland<br>
																Tel. 09 4772720 Email <a href="mailto:keithf@compassnzl.co.nz">keithf@compassnzl.co.nz</a>
															</span><br><br>
															<div style="text-transform: uppercase; font-weight: bold; font-size: 18px; letter-spacing: 1px; text-align: center;">
																CONTRACTOR IQP STATEMENT OF MAINTENANCE<br>
																<span style="font-size: 16px;">FOR ATTACHMENT TO REPORT IN LIEU OF FORM 12A -</span>
															</div>
														</div>
													</div>
													<!--Building Details-->
													<div style="border: 1px solid black; margin: 0 2rem;">
														<table width="100%" cellspacing="0" cellpadding="0">
															<tbody>
																<tr>
																	<td colspan="2" class="title">The Building</td>
																</tr>
																<tr class="btm-border">
																	<td><strong>Street address:</strong></td>
																	<td>{{propertyData.streetAddress}} {{propertyData.suburb}} {{propertyData.city}}</td>
																</tr>
																<tr class="btm-border">
																	<td><strong>Legal Description of land where building is located:</strong></td>
																	<td>{{bwof.legalDescription}}</td>
																</tr>
																<tr class="btm-border">
																	<td><strong>Building name / trading name:</strong></td>
																	<td>{{propertyData.buildingName}}</td>
																</tr>
																<tr class="btm-border">
																	<td><strong>Location of Building within site/block number:</strong></td>
																	<td>{{bwof.locationOfBuildingWithinSite}}</td>
																</tr>
																<tr>
																	<td style="padding-left: 10px;"><strong>Level/Unit Number:</strong><span>{{bwof.levelUnitNo}}</span></td>
																	<td> <div style="width: 345px; text-align: right;"><strong>CS #:</strong> <span>{{bwof.complianceSchedule}}</span></div></td>
																</tr>
															</tbody>
														</table>
													</div>
													<!--Owner Details-->
													<div style="border: 1px solid black; margin: 0 2rem;">
														<table width="100%" cellspacing="0" cellpadding="0">
															<tbody>
																<tr>
																	<td colspan="2" class="title">The Owner</td>
																</tr>
																<tr class="btm-border">
																	<td><strong>Name of Owner:</strong></td>
																	<td>{{owner.companyName}}</td>
																</tr>
																<tr class="btm-border">
																	<td><strong>Contact Person:</strong></td>
																	<td>{{ownerContact.firstName}} {{ownerContact.lastName}}</td>
																</tr>
																<tr class="btm-border">
																	<td><strong>Mailing Address:</strong></td>
																	<td>{{owner.postalAddress}} {{owner.suburb}} {{owner.city}}</td>
																</tr>
																<tr>
																	<td style="padding-left: 10px;"><strong>Street address / registered office:</strong><span>{{owner.streetAddress}}</span></td>
																	<td>&nbsp;</td>
																</tr>
															</tbody>
														</table>
													</div>
													<div style="border: 1px solid black; margin: 0 2rem; min-height: 150px;">
														<div class="title">
															Specified System Or Feature
														</div>
														<table width="100%" cellspacing="0" cellpadding="0">
															<tbody>
																<!--for each specified system or feature-->
																<template v-for="srv in visibleServices" v-bind:key="srv.serviceId">
																	<tr class="btm-border"><td><span>{{srv.ref}}</span></td><td>{{srv.serviceName}}</td></tr>
																</template>
															</tbody>
														</table>
													</div>
													<div style="border: 1px solid black; margin: 0 2rem;">
														<div class="title">
															Report
														</div>
														<table width="100%" cellspacing="0" cellpadding="0">
															<tbody>
																<tr class="btm-border">
																	<td colspan="3" style="padding: 0 10px;">
																		<strong>Compass New Zealand Ltd</strong>
																		offers the following IQP statements in support of an owner/owners agent
																		'Report in Lieu of Form 12A'. The guidance document published by the
																		Territorial Authority requires an IQP to provide statements in relation
																		to items 2 and 3 of the guidance document.
																	</td>
																</tr>
																<tr class="btm-border">
																	<td colspan="3">
																		<span style="font-style: italic;">
																			GUIDANCE ITEM 2: A
																			statement that any remedial work and/or inspection and maintenance on
																			the specified system/ feature has been carried out and that the
																			specified system/ feature is now in a compliant state and fully
																			operational.
																		</span>
																		<div contenteditable="true" class="editable-div">
																			Compass New Zealand Ltd certifies
																			that the inspection, maintenance, and reporting procedures of the
																			Compliance Schedule have been fully complied with during a period of
																			<span v-if="bwof.complianceScheduleMonths == 1">{{bwof.complianceScheduleMonths}} month</span><span v-else>{{bwof.complianceScheduleMonths}} months</span>
																			prior to the date of this statement.
																			A Form 12A was not provided on the basis that no/not all owner
																			inspections were available for the above features during the previous
																			twelve months. We understand the tenant was to complete Owner's
																			inspections during the 2019/2020 maintenance period; however this was
																			not done despite record book being available on site. We are confident
																			that systems are in place to ensure full maintenance and inspection in
																			accordance with the Compliance Schedule is carried out in future. An
																			annual IQP inspection of the above system(s)/feature(s) was complete
																			together with the owner's inspections due at that time. We found the
																			system(s)/feature(s) were maintained and in a compliant state
																			notwithstanding the lack of full owners inspection records.
																		</div>
																	</td>
																</tr>
																<tr class="btm-border">
																	<td colspan="3">
																		<span style="font-style: italic;">
																			GUIDANCE ITEM 3: A
																			statement that an Independent Qualified Person/Licensed Building
																			Practitioner has been and will continue to be engaged to inspect,
																			maintain and report on the specified feature /system.
																		</span>
																		<div contenteditable="true" class="editable-div">
																			Compass New Zealand Ltd are currently contracted on an ongoing basis to perform IQP inspection and reporting requirements, 
																			in respect of the specified system/features listed above, in accordance with the compliance schedule. 
																			We have received no advice that this relationship is scheduled to change
																		</div>
																	</td>
																</tr>
																<tr>
																	<td style="font-style: italic; padding: 0 10px;">Signed by building IQP #110459</td>
																	<td colspan="2">
																		<div style="height: 50px; font-weight: bold; padding: 0 10px;">
																			<div class="col mr-4 mt-2 css-image signature-keith" style="height:30px">
																			</div>
																			Keith Flatt - Managing Director - Compass New Zealand Limited
																		</div>
																	</td>
																</tr>
																<tr>
																	<td style="padding: 0 10px;"><strong>DATE:</strong> {{formattedDate(issuedDate || new Date())}}</td>
																	<td style="padding: 0 10px; width: 250px;"><strong>RELEVANT MAINTENANCE PERIOD: </strong></td>
																	<td style="padding: 0 10px;">
																		<div contenteditable="true" class="p-inputtext editable-div">
																			xx-xx-2019 to xx-xx-2020
																		</div>
																	</td>
																</tr>
															</tbody>
														</table>
													</div>
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</td><!-- MainBody Ends -->
						</tr>
					</tbody>
				</table>
			</div>
			<!-- body end -->
		</div>
	</div>
</template>

<script lang="ts">
	import { Vue, Options } from 'vue-class-component';
	import { PropertyData, CompanyData, PropertyBwofData, ContactData, PropertyServiceData } from '@/api-client/api-client'
	import { format, isValid } from 'date-fns';

	@Options({
		name: 'ContractorIQPStatementTemplate',
		props: {
			propertyData: null,
			service: null,
			issuedDate: Date
		}
	})
	export default class ContractorIQPStatementTemplate extends Vue {

		// Data
		propertyData: PropertyData = new PropertyData;
		ownerContact: ContactData = new ContactData;
		service: PropertyServiceData = new PropertyServiceData;
		owner: CompanyData = new CompanyData;
		bwof: PropertyBwofData = new PropertyBwofData;
		issuedDate: Date = new Date();

		created() {
			if (this.propertyData) {
				// Set Owner
				this.owner = this.propertyData.owner ? this.propertyData.owner : this.owner;

				// Set BWOF
				if (this.propertyData.propertyBwof)
					this.bwof = this.propertyData.propertyBwof;

				// Set Owner Contact from BWOF
				this.ownerContact = this.bwof.ownerContact != null ? this.bwof.ownerContact : this.ownerContact;
			}
		}

		formattedDate(date: Date) : string {
			if (!isValid(date)) return "";

			return format(date, 'd MMMM yyyy');
		}

		get visibleServices() {
			let services: PropertyServiceData[] = [];

			if (this.service.parentServiceId == null && this.propertyData.services) {
				
				services = this.propertyData.services.filter(s => s.parentServiceId == this.service.serviceId);
			} else {
				services.push(this.service);
			}

			return services;
		}

	}
</script>

<style scoped lang="scss">
	body, table td {
		font-size: 12px;
		line-height: 20px;
		font-family: arial, sans serif;
	}

	.title {
		text-align: center;
		font-size: 14px;
		text-transform: uppercase;
		font-weight: bold;
		border-bottom: 2px solid black;
	}

	.full-width {
		width: 750px;
	}

	.btm-border td {
		border-bottom: 1px solid gray;
		padding: 0 10px;
	}

	@media print {
		.full-width {
			width: 100%;
		}

		div#overall-body {
			width: 100%;
			height: 600px;
			background-color: white;
		}

		textarea {
			resize: none;
		}
	}

	textarea {
		width: 100%;
		padding: 0;
		border: none;
		margin: 5px 0;
		font-size: 12px;
	}

	.editable-div {
		padding: 0;
		border: none;
		margin: 5px 0;
		font-size: 12px;
		background-color: white;
		color: black;
		resize: vertical;
		overflow: auto;
	}
</style>